import IconButton from 'LuxKit/Button/IconButton'
import LinePhoneIcon from 'LuxKit/Icons/line/LinePhoneIcon'
import ModalContext from 'contexts/ModalContext'
import type { ComponentProps } from 'react'
import { useCallback, useContext } from 'react'
import { useIntl } from 'react-intl'
import HeaderContactOptionsModal from './HeaderContactOptionsModal'

type InheritedIconButtonProps = Pick<ComponentProps<typeof IconButton>, 'size' | 'className'>

interface Props extends InheritedIconButtonProps {
}

function HeaderContactOptionsMenu(props: Props) {
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const openModal = useCallback(() => {
    showModal(<HeaderContactOptionsModal />)
  }, [showModal])

  return <IconButton
    {...props}
    kind="tertiary"
    onClick={openModal}
    variant="default"
    aria-label={intl.formatMessage(
      {
        id: '-B6GXtY4T1fz0Ca802Yb',
        defaultMessage: 'Need Help? Call our Travel Experts',
        description: 'Contact options menu button aria label in the customer support section',
      },
    )}
    rel="nofollow"
  >
    <LinePhoneIcon />
  </IconButton>
}

export default HeaderContactOptionsMenu
